import React from "react"
import Box from '@mui/material/Box'

function LayoutBox(props) {

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                boxSizing: 'border-box',
                mx: 'auto',
                maxWidth: '1580px',
                width: {md: '100%', xs: '90%'}
            }}
            {...props}
        />

    )
}

export default LayoutBox